import Vue from 'vue';
import Router from 'vue-router';

import LoginPage from '../pages/LoginPage.vue';
import DashboardPage from '../pages/DashboardPage.vue';
import ModuleCenterPage from '../pages/ModuleCenterPage.vue';
import EvaluationPage from "../pages/EvaluationPage.vue"
import EvaluationComponent from "../components/EvaluationComponent.vue"
import UserList from "../components/UserList.vue"
// import TrainingCenterPage from "../pages/TrainingCenterPage.vue";
import AssigneeTaskPage from '../pages/AssigneeTaskPage.vue';
import ReporterPage from '../pages/ReporterPage.vue';
import EmployeePage from '../pages/EmployeePage.vue';
import EnrolledTrainingPage from '../pages/EnrolledTrainingPage.vue';
import TrainingPage from '../pages/TrainingPage.vue';
import AuthLayout from '../layouts/AuthLayout.vue';
import TrainingLayout from '../layouts/TrainingLayout.vue';
import TrainingCenterLayout from '../layouts/TrainingCenterLayout.vue';
import TrainingDescriptionPage from '../pages/TrainingDescriptionPage.vue';

import CreatedTrainingPage from '../components/CreatedTrainingListComponent.vue';
import ReporteesTrainingPage from '../components/ReporteesListComponent.vue';

// import ReporteeTrainingDetailPage from "../pages/ReporteeTrainingDetailPage.vue";

import EmployeeWorkSheetPage from '../layouts/EmployeeWorkSheetPage.vue';
import WorkSheetPage from '../pages/WorkSheetPage.vue';
// import WorkSheetDetailPage from "../layouts/WorkSheetEntityPage.vue";

import { getToken } from '../utils/storage';

import store from '@/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/login',
            name: 'LoginPage',
            component: LoginPage,
            beforeEnter: (to, _, next) => {
                const token = getToken();
                if (to.name === 'LoginPage' && token && token.userId && token.role) {
                    if (!store.state.Auth.user) {
                        const user = getToken();
                        console.log(store.commit('Auth/setUser', user));
                        console.clear();
                    }
                    return next({ name: 'EnrolledTrainingPage' });
                } else {
                    return next();
                }
            },
        },
        {
            path: '',
            component: AuthLayout,
            children: [
                {
                    path: '/dashboard',
                    name: 'DashboardPage',
                    component: DashboardPage,
                },
                {
                    path: '/mytasks/:workSheetId',
                    name: 'AssigneeTaskPage',
                    component: AssigneeTaskPage,
                },
                {
                    path: '/module-center',
                    name: 'ModuleCenterPage',
                    component: ModuleCenterPage,
                },
                {
                    path: '/training-center',
                    component: TrainingCenterLayout,
                    redirect: '/training-center/created',
                    children: [
                        {
                            path: 'created',
                            name: 'CreatedTrainingPage',
                            component: CreatedTrainingPage,
                        },
                        {
                            path: 'reportees',
                            name: 'ReporteesTrainingPage',
                            component: ReporteesTrainingPage,
                        },
                    ],
                },
                {
                    path: '/evaluation',
                    component: EvaluationPage,
                    name: 'EvaluationPage',
                    children: [
                        {
                            path: ':trainingId',
                            component : UserList,
                            name: 'UserList',
                            children:[
                                {
                                    path:':userId',
                                    component: EvaluationComponent,
                                    name: 'EvaluationComponent'
                                }
                            ]
                        },
                        // {
                        //     path: '/:userId',
                        //     component : EvaluationComponent,
                        //     name: 'EvaluationComponent'
                        // }
                    ]
                },
                {
                    path: '/employee',
                    name: 'EmployeePage',
                    component: EmployeePage,
                },
                {
                    path: '/training',
                    component: TrainingLayout,
                    redirect: '/training/enrolled',
                    children: [
                        {
                            path: 'enrolled',
                            name: 'EnrolledTrainingPage',
                            component: EnrolledTrainingPage,
                        },
                        {
                            path: 'catalog',
                            name: 'TrainingPage',
                            component: TrainingPage,
                        },
                    ],
                },
                {
                    path: '/worksheet/:id',
                    name: 'WorkSheetPage',
                    component: WorkSheetPage,
                },
                {
                    path: '/training/:id',
                    name: 'TrainingDescriptionPage',
                    component: TrainingDescriptionPage,
                },
                {
                    path: '/reportees',
                    name: 'ReporterPage',
                    component: ReporterPage,
                    children: [
                        {
                            path: ':userId',
                            name: 'ReporteeWorkSheetPage',
                            component: EmployeeWorkSheetPage,
                        },
                    ],
                },
            ],
            beforeEnter: (to, from, next) => {
                checkValidation(next);
                checkRoleAccess(to, next);
            },
        },
        // {
        //   path: "*",
        //   name: "ErrorPage",
        //   component: "<div>errror</div>",
        // },
    ],
});

const checkValidation = (next) => {
    const token = getToken();
    if (token) {
        if (token.userId && token.role) {
            if (!store.state.Auth.user) {
                const user = getToken();
                console.log(store.commit('Auth/setUser', user));
                console.clear();
            }
            return next();
        } else {
            return next({ name: 'LoginPage' });
        }
    } else {
        return next({ name: 'LoginPage' });
    }
};

const checkRoleAccess = (to, next) => {
    const token = getToken();
    if (token) {
        if (token.role == 'USER' && (to.path == '/employee' || to.path == '/module-center')) {
            return next({ path: '/training' });
        } else {
            return next();
        }
    }
};

export default router;
